var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center p-3"},[(_vm.linkMessage !== undefined)?_c('div',[_vm._v(" "+_vm._s(_vm.linkMessage)+" ")]):_c('div',[_c('b-spinner',{attrs:{"size":"sm"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }